import { render, staticRenderFns } from "./SentDialogResend.vue?vue&type=template&id=b7a7ac34&scoped=true&"
import script from "./SentDialogResend.vue?vue&type=script&lang=js&"
export * from "./SentDialogResend.vue?vue&type=script&lang=js&"
import style0 from "./SentDialogResend.vue?vue&type=style&index=0&id=b7a7ac34&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7a7ac34",
  null
  
)

export default component.exports